<template>
  <div>
    <Navbar stageTitle="Workspace" />
    <div class="pm-workspace">
      <div class="pm-container">
        <div class="progress-report-wrapper">
          <ProjectReport />
          <div class="project-activity">
            <ActivityLog v-bind="{ projectActivity, teamMembers }" />
          </div>
        </div>
        <div class="container-divider"></div>
        <!-- <SprintReport /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Navbar from "@/components/general/toolbar";
import ActivityLog from "@/components/workspace/activityLog";
import SprintReport from "@/components/workspace/sprintReport1";
import ProjectReport from "@/components/workspace/clientProjectReport";
export default {
  props: {},
  components: {
    Navbar,
    ActivityLog,
    SprintReport,
    ProjectReport,
  },

  data: () => ({}),

  created() {},
  methods: {},
  computed: {
    ...mapState("clientDashboard", [
      "clientProject",
      "clientProjectDoc",
      "projectActivity",
      "projectTeam",
    ]),
    teamMembers() {
      return this.projectTeam;
    },
  },
};
</script>
<style scoped>
* {
  font-family: Moderat;
  font-style: normal;
  font-weight: normal;
}
</style>
